import {JustificativaResumo} from '../types'
import {fmtDate, FEEDBACK} from '../ui'

interface Props {
    justificativas: JustificativaResumo[]
    loading: boolean
    /** Abrir uma concluída (leitura/reabertura). */
    onAbrir: (id: string) => void
    /** Retomar um RASCUNHO (entrevista salva pela metade) de onde parou. */
    onRetomar: (id: string) => void
    /** Estado vazio amigável (customizável por contexto — landing x página cheia). */
    vazioTitulo?: string
    vazioDescricao?: string
}

function statusChip(status: string): {label: string; color: string; bg: string} {
    switch (status) {
        case 'RASCUNHO': return {label: 'Rascunho', color: FEEDBACK.info, bg: FEEDBACK.infoSoft}
        case 'APTA': return {label: 'Apta', color: FEEDBACK.success, bg: FEEDBACK.successSoft}
        case 'COM_RISCO': return {label: 'Com risco', color: FEEDBACK.warning, bg: FEEDBACK.warningSoft}
        case 'ERRO': return {label: 'Erro', color: FEEDBACK.danger, bg: FEEDBACK.dangerSoft}
        case 'PROCESSANDO': return {label: 'Processando', color: FEEDBACK.info, bg: FEEDBACK.infoSoft}
        default: return {label: status, color: FEEDBACK.muted, bg: FEEDBACK.mutedSoft}
    }
}

/** Lista de casos (rascunhos + concluídas) em cards clicáveis — presentacional,
 * reusada pela HistoricoView (página cheia) e pela landing da busca. Rascunho →
 * "Retomar" (onRetomar); concluída → "Abrir" (onAbrir). */
export default function JustificativasList({
    justificativas, loading, onAbrir, onRetomar,
    vazioTitulo = 'Nenhuma justificativa ainda',
    vazioDescricao = 'Pesquise uma ata, avalie a adesão e gere a primeira justificativa.',
}: Props) {
    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: 14}}>
            {loading && (
                <div className="lg-empty"><div className="lg-empty__title">Carregando…</div></div>
            )}

            {!loading && justificativas.length === 0 && (
                <div className="lg-empty">
                    <svg className="lg-empty__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                    <div className="lg-empty__title">{vazioTitulo}</div>
                    <div className="lg-empty__description">{vazioDescricao}</div>
                </div>
            )}

            {!loading && justificativas.map((j) => {
                const st = statusChip(j.status)
                const rascunho = j.status === 'RASCUNHO'
                return (
                    <div key={j.id} className="ata-card">
                        <div className="ata-card__top">
                            <div>
                                <div className="ata-card__objeto" style={{fontSize: 'var(--fs-base)'}}>{j.objeto || j.ata_numero_controle}</div>
                                <div className="ata-card__org">
                                    <span style={{color: 'var(--text-tertiary)'}}>Ata {j.ata_numero_controle}</span>
                                    {rascunho && j.atualizado_em
                                        ? <span style={{color: 'var(--text-tertiary)'}}>· editado em {fmtDate(j.atualizado_em.slice(0, 10))}</span>
                                        : j.criado_em && <span style={{color: 'var(--text-tertiary)'}}>· {fmtDate(j.criado_em.slice(0, 10))}</span>}
                                </div>
                            </div>
                            <span className="selo" style={{color: st.color, background: st.bg}}>{st.label}</span>
                        </div>
                        <div className="ata-card__actions" style={{borderTop: '1px solid var(--border-subtle)', paddingTop: 12, marginTop: 4}}>
                            <span />
                            {rascunho
                                ? <button className="lg-btn lg-btn--brand lg-btn--sm" onClick={() => onRetomar(j.id)}>Retomar</button>
                                : <button className="lg-btn lg-btn--brand lg-btn--sm" onClick={() => onAbrir(j.id)}>Abrir</button>}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
